import '@assets/styles/pages/addNewSiteLead.scss';
import { ReactElement } from 'react';
import { SiteVisit } from '@components/siteVisit';

export const VisitDetailsPage = (): ReactElement => {
	return <SiteVisit />;
};
